
  import {Component, Model, Prop, Vue, Watch} from "vue-property-decorator";
  import api from '@/api/index'
  import {OrganizationUnitDto, StringStringKeyValuePair} from "@/api/appService";

    @Component({name:'OrganizationUnitQuerySelect'})
    export default class OrganizationUnitQuerySelect extends Vue{

      @Model('change',{type:String,})readonly organizationUnitId!:string;

      @Prop({required:false})
      levelFilter?:string;


      organizationUnits:StringStringKeyValuePair[] = [{key:'All',value:'查看所有'}];
      currentOu:any;

      orgId:string = 'All';
      showSelect:boolean = false;

      beforeCreate(){
        this.currentOu = this.$store.getters['user/ou'] as OrganizationUnitDto  ;
      }

      async created(){
        if(this.currentOu.level === '门店'){
          this.$emit('change',this.currentOu.id);
        } else {
          this.showSelect = true;
          this.orgId = 'All';
          this.$emit('change',this.orgId);

          await api.organizationUnit.getOrganizationUnitsOfDescendantBySession({withMe:false}).then(res=>{
            let responseItems = res;
            if(this.levelFilter){
              responseItems = responseItems.filter(org=>this.levelFilter!.indexOf(org?.level?.toString()??"")>0);
            }
            let selectList:StringStringKeyValuePair[] = responseItems.map(org=>{
              return {
                key:((org?.id)?.toString()??""),
                value:(org?.displayName??"")
              };
            });
            this.organizationUnits = [{key:'All',value:'查看所有'},{key:'OnlyMe',value:'只看自己'},...selectList];
          });
        }
      }

      handleValueChange(value:string){
        this.$emit('change',value);
      }

      @Watch('organizationUnitId')
      handleOrganizationUnitIdChange(newValue:string){
        console.log('handleOrganizationUnitIdChange:'+newValue);
        this.orgId = newValue;
      }

    }
